<template>
  <div class="px-6 py-4">
    <button
      type="button"
      class="w-full py-2.5 bg-[#1c4848]/5 hover:bg-[#1c4848]/10 border border-dashed border-[#1c4848]/20 rounded-xl flex items-center justify-center gap-2 text-xs font-bold text-[#1c4848] transition-all group"
      @click="$emit('click')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 group-hover:scale-110 transition-transform"><circle cx="12" cy="12" r="10"></circle><path d="M8 12h8"></path><path d="M12 8v8"></path></svg>
      <span>{{ label }}</span>
    </button>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, default: 'Add New Page' }
});
defineEmits(['click']);
</script>
